import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { KeyRound, Mail, ArrowLeft } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSubmitted(true);
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="max-w-md mx-auto my-16" data-testid="forgot-password-success">
        <div className="card-surface p-8 text-center space-y-4">
          <div className="w-14 h-14 rounded-full bg-[#C5A059]/15 border border-[#C5A059]/30 flex items-center justify-center mx-auto">
            <Mail className="w-6 h-6 text-[#C5A059]" strokeWidth={1.5} />
          </div>
          <h1 className="font-serif text-3xl text-[#FDFBF7]">Check your inbox</h1>
          <p className="text-[#A1A4AB]">
            If this email is connected to an account, a password reset link has been sent.
            The link expires in 30 minutes.
          </p>
          <Link to="/login" className="btn-ghost text-sm inline-flex items-center gap-1.5" data-testid="forgot-back-to-login">
            <ArrowLeft className="w-4 h-4" strokeWidth={1.5} /> Back to sign in
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto my-16">
      <div className="overline text-[#C5A059] mb-3 text-center">Recover access</div>
      <h1 className="font-serif text-4xl text-center text-[#FDFBF7] tracking-tight mb-2">Forgot your password?</h1>
      <p className="text-center text-[#A1A4AB] mb-8">Enter your email and we'll send you a reset link.</p>
      <form onSubmit={submit} className="space-y-4 card-surface p-8" data-testid="forgot-password-form">
        <div>
          <label className="text-sm text-[#A1A4AB] mb-2 block">Email</label>
          <input
            type="email" required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input-lux"
            data-testid="forgot-email-input"
            placeholder="you@example.com"
          />
        </div>
        {err && <div className="text-sm text-red-400" data-testid="forgot-error">{err}</div>}
        <button type="submit" disabled={loading || !email} className="btn-primary w-full justify-center" data-testid="forgot-submit-btn">
          <KeyRound className="w-4 h-4" strokeWidth={1.5} /> {loading ? "Sending..." : "Send reset link"}
        </button>
        <div className="text-center text-sm text-[#A1A4AB] pt-2">
          <Link to="/login" className="text-[#C5A059] hover:text-[#DCC286]" data-testid="forgot-to-login-link">
            Back to sign in
          </Link>
        </div>
      </form>
    </div>
  );
}
